<template>
    <div>
        <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
              <div class="flex items-center justify-between con-btns-user">
                <div class="flex items-center justify-start con-userx">
                  <vs-avatar color="primary" :text="lead.first_name"/>
                  <span class="font-semibold text-primary">{{ lead.company_name || lead.first_name }}( {{
                      lead.code
                    }} ) </span>

                   <vs-chip size="small" class="ml-2" transparent color="#7952B3">
                      {{ lead.status }}
                    </vs-chip>

                </div>
                <div class="flex">

                </div>
              </div>
            </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
        <div class="w-full vx-col" v-if="is_load">
            <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
                id="profile-tabs" :key="isSmallerScreen">

                <vs-tab icon-pack="feather" icon="icon-file" :label="!isSmallerScreen ? 'Profile' : ''">
                    <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                        <LeadProfile/>
                    </div>
                </vs-tab>
                <vs-tab icon-pack="feather" icon="icon-home" :label="!isSmallerScreen ? 'Sites & Addresses' : ''">
                    <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                        <LeadSites/>
                    </div>
                </vs-tab>
                <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Enquries' : ''">
                    <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                        <LeadEnquiries/>
                    </div>
                </vs-tab>
                <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Sample Orders' : ''">
                    <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                        <LeadSampleOders :customer_id="lead.customer_id"/>
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
    </div>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory';
const CrmRepository = RepositoryFactory.get('crm');
import LeadProfile from './lead-tabs/LeadProfile.vue'
import LeadSites from './lead-tabs/LeadSites.vue';
import LeadEnquiries from './lead-tabs/LeadEnquiries.vue';
import LeadSampleOders from './lead-tabs/LeadSampleOders.vue';

export default {
    name: "MememberHome",
    methods: {
        async fetchMemberDetails() {
            try {
                const { data } = (await CrmRepository.getMerketingLeadDetails(this.id)).data
                this.lead = data
            } catch (error) {

            }
        }
    },
    components: {
        LeadProfile,
        LeadSites,
        LeadEnquiries,
        LeadSampleOders
    },
    mounted() {
        this.id = this.$route.params.id
        this.fetchMemberDetails()
    },
    data() {
        return {
            active_step: this.$route.query.step ? this.$route.query.step : '0',
            id: '',
            lead: {
                status: '',
                first_name: '',
                code: '',
                company_name: ''
            },
            is_load: true
        }
    },
    computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
}
</script>